import {FieldConfig} from '../../dynamic-field/field.config';
import {InjectionToken} from '@angular/core';

export enum DatePickerModeEnum {
    date = 'date',
    month = 'month',
    year = 'year',
}

export interface DateFieldConfig extends FieldConfig<Date> {
    maxDate?: Date | null;
    minDate?: Date | null;
    spinner?: boolean;
    placeholder?: string;
    showTodayButton?: boolean;
    leftArrowClick?: () => void;
    rightArrowClick?: () => void;
    dateFilter?: (data) => boolean;
    getDateClass?: (date: Date, view: string) => string;
    mode?: DatePickerModeEnum;

}
